//
// Player Functions
// --------------------

/**
 * @param {HTMLElement} item
 * @returns {object}
 */
export function getItemDetails (item) {
  /** @type {string} */
  let artist = item.querySelector('.player__item-artist').textContent
  /** @type {string} */
  let image = item.querySelector('.player__item-cover').src
  /** @type {string} */
  let title = item.querySelector('.player__item-title').textContent
  /** @type {string | void} */
  let src = item.dataset.src || null
  return { artist, image, title, src }
}

/**
 * @param {number} seconds
 * @param {string} [separator]
 * @returns {string}
 */
export function readableTime (seconds, separator = ':') {
  seconds = parseInt(seconds, 10)
  const pad = i => i > 9 ? i : '0' + i
  return [
    ~~((seconds % 3600) / 60), pad(~~seconds % 60)
  ].filter(Boolean).join(separator)
   .padStart(4, `0${separator}0`)
}
